// Legacy AYTM text-collision layout, moved as-is from
// public/javascripts/_d3/d3_mod.layout.aytm_text_collisions.js. Needs d3 v3 for
// d3.geom.quadtree (absent from npm d3 v7) — fed by the module-scoped copy.
// Only strict-mode fixes applied — implicit globals declared.
import d3 from '@aytm/app/stats/components/topography/d3v3'

// Ideas:
// At the start we should check 0, 90, 180, 270 angles, if the are not empty, start main one.
// count intersection square.
// in the case of 0, 180 we should check couple additional places. (move label box by x (axis +/- 1,2,3,4 pixels) )

var layoutExports = {}

;(function (exports) {
  function aytmTextCollisions() {
    var instance = {}
    var w = 1
    var h = 1
    var circlePadding = 2
    var angleStep = 5
    var angleFrom = 270
    var debug = false

    instance.size = function (v1, v2) {
      w = v1
      h = v2
      return instance
    }

    instance.setCirclePadding = function (v) {
      circlePadding = v
      return instance
    }

    instance.setAngleStep = function (v) {
      angleStep = v
      return instance
    }

    instance.setAngleFrom = function (v) {
      angleFrom = (360 - v) % 360
      return instance
    }

    instance.setDebug = function (v) {
      debug = v
      return instance
    }

    instance.run = function (objs) {
      var resp = {}
      var piFactor = Math.PI / 180.0

      var quadtree = d3.geom.quadtree().extent([
        [0, 0],
        [w, h]
      ])([])

      if (debug) var ph = d3.select('body').append('svg').attr('width', w).attr('height', h)

      var lines = []

      var maxRadius = 0

      for (var i = 0; i < objs.length; i++) {
        if (objs[i].circle) {
          quadtree.add([objs[i].circle.x, objs[i].circle.y, objs[i].circle.r, { type: 'c' }])
          maxRadius = Math.max(maxRadius, objs[i].circle.r)

          if (debug)
            ph.append('circle')
              .attr('cx', objs[i].circle.x)
              .attr('cy', objs[i].circle.y)
              .attr('r', objs[i].circle.r + circlePadding - 2)
              .attr('fill', '#33333')
        } else if (objs[i].line) {
          lines.push(objs[i].line)

          if (debug)
            ph.append('line')
              .attr('x1', objs[i].line.x1)
              .attr('y1', objs[i].line.y1)
              .attr('x2', objs[i].line.x2)
              .attr('y2', objs[i].line.y2)
              .attr('stroke', 'gray')
              .attr('stroke-width', 2)
        } else if (objs[i].rect) {
          var rw2 = objs[i].rect.w / 2
          var rh2 = objs[i].rect.h / 2

          quadtree.add([
            objs[i].rect.x + rw2,
            objs[i].rect.y + rh2,
            Math.max(rw2, rh2),
            { type: 'r', x: objs[i].rect.x, y: objs[i].rect.y, w: objs[i].rect.w, h: objs[i].rect.h }
          ])

          if (debug)
            ph.append('rect')
              .attr('x', objs[i].rect.x)
              .attr('y', objs[i].rect.y)
              .attr('width', objs[i].rect.w)
              .attr('height', objs[i].rect.h)
              .attr('fill', 'grey')
        }
      }

      for (var i = 0; i < objs.length; i++) {
        if (!objs[i].label) continue

        var lw = objs[i].label.w
        var lh = objs[i].label.h
        var lw2 = lw / 2
        var lh2 = lh / 2

        var cx = objs[i].circle.x
        var cy = objs[i].circle.y
        var cr = objs[i].circle.r

        var bestX = null
        var bestY = null
        var bestDiff = Number.MAX_VALUE
        var angle = 0

        var d = lw > lh ? lw : lh
        var searchRadius = maxRadius + d

        var iterationsLeft = 5
        var iteration = 0
        while (bestDiff > 0.1 && iterationsLeft > 0) {
          var internalAngle = (angleFrom + angle) % 360

          var newX = cx + (circlePadding + cr + iteration * 10) * Math.cos(piFactor * internalAngle)
          var newY = cy + (circlePadding + cr + iteration * 10) * Math.sin(piFactor * internalAngle)

          if (angle > 5 && angle < 175) newX += lw2
          else if (angle > 185 && angle < 355) newX -= lw2

          if (angle > 95 && angle < 265) newY += lh2
          else if (angle < 85 || angle > 275) newY -= lh2

          if (inArea(0, 0, w, h, newX - lw2, newY - lh2, lw, lh)) {
            var rx1 = newX - searchRadius
            var rx2 = newX + searchRadius
            var ry1 = newY - searchRadius
            var ry2 = newY + searchRadius

            var diff = 0
            var circleCollisionOn = false
            var rectCollision = false
            var lineCollisionOn = false

            quadtree.visit(function (quad, x1, y1, x2, y2) {
              if (quad.point) {
                var p = quad.point

                if (p[3].type === 'c') {
                  if (circleCollision(p[0], p[1], p[2], newX - lw2, newY - lh2, lw, lh, circlePadding)) {
                    circleCollisionOn = true
                    diff += p[2]
                  }
                } else if (p[3].type === 'r') {
                  if (rectangleCollision(p[3].x, p[3].y, p[3].w, p[3].h, newX - lw2, newY - lh2, lw, lh)) {
                    rectCollision = true
                    diff += lw + p[3].w - Math.abs(p[3].x - newX)
                    diff += lh + p[3].h - Math.abs(p[3].y - newY)
                  }
                }

                return x1 > rx2 || x2 < rx1 || y1 > ry2 || y2 < ry1
              }
            })

            if (!circleCollisionOn && !rectCollision) {
              for (var j = 0; j < lines.length; j++) {
                if (lineCollision(lines[j].x1, lines[j].y1, lines[j].x2, lines[j].y2, newX - lw2, newY - lh2, lw, lh)) {
                  lineCollisionOn = true
                  diff += 10
                }
              }
            }

            if (debug) {
              var collisionColor = ''

              if (circleCollisionOn) collisionColor = '#999'
              else if (lineCollisionOn) collisionColor = '#009900'
              else if (!rectCollision) collisionColor = '#990000'

              if (collisionColor !== '')
                ph.append('rect')
                  .attr('x', newX - lw2)
                  .attr('y', newY - lh2)
                  .attr('width', lw)
                  .attr('height', lh)
                  .attr('fill', collisionColor)
            }

            if (diff < bestDiff) {
              bestDiff = diff
              bestX = newX
              bestY = newY
            }
          }
          angle += angleStep

          if (angle > 360) {
            iteration += 1
            iterationsLeft -= 1
            angle = 0
          }
        }

        if (bestX !== null) {
          quadtree.add([bestX, bestY, d, { type: 'r', x: bestX - lw2, y: bestY - lh2, w: lw, h: lh }])

          resp[objs[i].id] = {}
          resp[objs[i].id].x = bestX - lw2
          resp[objs[i].id].y = bestY + lh2
          resp[objs[i].id].text = objs[i].label.text
        }
      }

      return resp
    }

    return instance
  }

  var rectangleCollision = function (x1, y1, w1, h1, x2, y2, w2, h2) {
    return !(x1 > x2 + w2 || x1 + w1 < x2 || y1 > y2 + h2 || y1 + h1 < y2)
  }

  var inArea = function (x1, y1, w1, h1, x2, y2, w2, h2) {
    return x1 + w1 >= x2 + w2 && x1 <= x2 && y1 + h1 >= y2 + h2 && y1 <= y2
  }

  // http://stackoverflow.com/questions/401847/circle-rectangle-collision-detection-intersection
  var circleCollision = function (cx, cy, r, x, y, w, h, padding) {
    var rr = r + padding - 2

    var rw2 = w / 2
    var rh2 = h / 2

    var rcx = x + rw2
    var rcy = y + rh2

    var dx = Math.abs(cx - rcx)
    var dy = Math.abs(cy - rcy)

    if (dx > rr + rw2 || dy > rr + rh2) return false

    if (dx <= rw2 || dx <= rh2) return true

    return Math.pow(dx - rw2, 2) + Math.pow(dy - rh2, 2) <= Math.pow(rr, 2)
  }

  var lineCollision = function (x1, y1, x2, y2, x, y, w, h) {
    if (lineLineCollision(x1, y1, x2, y2, x, y, x + w, y)) return true
    if (lineLineCollision(x1, y1, x2, y2, x, y, x, y + h)) return true
    if (lineLineCollision(x1, y1, x2, y2, x + w, y, x + w, y + h)) return true
    if (lineLineCollision(x1, y1, x2, y2, x, y + h, x + w, y + h)) return true

    return false
  }

  var lineLineCollision = function (a, b, c, d, p, q, r, s) {
    var det, gamma, lambda
    det = (c - a) * (s - q) - (r - p) * (d - b)
    if (det === 0) {
      return false
    } else {
      lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det
      gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det
      return 0 < lambda && lambda < 1 && 0 < gamma && gamma < 1
    }
  }

  exports.aytmTextCollisions = aytmTextCollisions
})(layoutExports)

export const aytmTextCollisions = layoutExports.aytmTextCollisions
